import { render, staticRenderFns } from "./InvMakeQuery.vue?vue&type=template&id=2166f49a&scoped=true"
import script from "./InvMakeQuery.vue?vue&type=script&lang=js"
export * from "./InvMakeQuery.vue?vue&type=script&lang=js"
import style0 from "./InvMakeQuery.vue?vue&type=style&index=0&id=2166f49a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2166f49a",
  null
  
)

export default component.exports